import React, { useContext, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Link, useLocation } from "react-router-dom";

import LoadingSpinner from "../common/LoadingSpinner";
import axios from "axios";
import {  baseServiceUrl, urls } from "../../environment";
import useUserStore from "../../stores/useUserStores";
const LoginAdmin = () => {
  const location = useLocation();
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const errornotify = (msg: any) => toast.error(msg);
  const [loginbtn, setloginbtn] = useState(false);
  const {
    setislogin,
    setisAdmin,
    setToken,
    setLoading,

    setisTestCentreAdmin,
    isTestCentreAdmin,
    setIsQuestionSynced,
    isQuestionSynced,
    setuserdetail,
    setResultUploadedForOfflineCentre,
    isResultUploadedForOfflineCentre,
    setIsResultUploadedUploadedForOfflineCentre,
  } = useUserStore();

  const tryLogin = async () => {
    setloginbtn(true);
    if (username === "" || password === "") {
      errornotify("All fields are required");
      setloginbtn(false);
      return;
    }
    try {
      setLoading(true);
      // const basePath =
      //   location.pathname === `/admin-login-centerwise`
      //     ? baseServiceOfflineUrl
      //     : baseServiceUrl;
      const response = await axios.post(baseServiceUrl + urls.adminLoginUrl, {
        user: {
          email: username,
          password: password,
        },
      });
      if (response.data && location.pathname === `/admin-login-centerwise`) {
        setIsQuestionSynced(response.data?.sync ?? false);
      }

      if (!!response && response.data && !!response.data.user) {
        if (response?.data?.user?.userType !== "USER")
          throw new Error("Invalid User");
        setuserdetail(response.data.user);
        setToken(response.data.user.token);
        setislogin(true);
        setisAdmin(true);
      } else {
        setloginbtn(false);
      }
    } catch (err: any) {
      setloginbtn(false);
      errornotify(
        (err && err?.message) ||
          err?.response?.data?.message ||
          "Error encounter. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {/* <Toaster position="bottom-left" reverseOrder={false} /> */}
      <section className="flex min-h-[90vh] justify-center items-center z-40">
        <div className="p-6 max-sm:px-3 bg-white space-y-4 rounded-sm  min-w-[25%] max-sm:w-[94%] max-lg:w-[50%] max-xl:w-[40%]  shadow-md ">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900">
            {location.pathname === `/admin-login-centerwise`
              ? `Test Centre Login`
              : `Admin Login`}
          </h1>
          <form className="space-y-4">
            <div className="flex flex-col">
              <label
                htmlFor="username"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="example@gmail.com"
                onChange={(e) => {
                  setusername(e.target.value);
                }}
                value={username}
                className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block p-2.5"
                required
              ></input>
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="••••••••"
                onChange={(e) => {
                  setpassword(e.target.value);
                }}
                value={password}
                className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5"
              ></input>
            </div>
            <button
              type="button"
              onClick={tryLogin}
              className={`w-full bg-[#2d69eb] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm px-5 py-2.5 mt-[10px] text-center`}
              disabled={loginbtn}
            >
              Sign in
            </button>
          </form>
        </div>
      </section>
      <div className="h-[100vh] w-[100vw] bg-AdminLogin blur-sm bg-no-repeat bg-cover bg-center bg-fixed absolute top-0 z-[-1]"></div>
    </>
  );
};

export default LoginAdmin;
